(function () {
    angular.module('st')
        .controller('lrWatchlistCtrl', [
            '$rootScope', '$scope',
            function ($rootScope, $scope) {
                var ctrl = this;
                var SCROLL_INTERVAL = 15;
                ctrl.scrollWrapper = document.querySelector('#scrollWrapper');
                ctrl.watchlist = [];
                ctrl.moveLeft = moveLeft;
                ctrl.moveRight = moveRight;
                ctrl.stopMoving = stopMoving;

                setWatchlistData();

                $scope.$watch('ctrl.watchlistRaw', function (newValue, oldValue) {
                    setWatchlistData();
                });

                function stopMoving() {
                    if (ctrl.leftTimeout) clearTimeout(ctrl.leftTimeout);
                    if (ctrl.rightTimeout) clearTimeout(ctrl.rightTimeout);
                }

                function moveLeft() {
                    var wraps = document.querySelectorAll('#scrollWrapper');

                    for (var i = 0; i < wraps.length; i++) {
                        if (wraps[i].parentElement.scrollWidth > 0) {
                            ctrl.scrollWrapper = wraps[i];
                            break;
                        }
                    }

                    if (!ctrl.scrollWrapper) {
                        return;
                    }

                    if (!ctrl.scrollWrapper.scrollLeft) {
                        ctrl.scrollWrapper.scrollLeft = 0;
                        return;
                    }

                    var nextPosition = ctrl.scrollWrapper.scrollLeft - SCROLL_INTERVAL;

                    if (nextPosition <= 0) {
                        ctrl.scrollWrapper.scrollLeft = 0;
                        return;
                    }

                    ctrl.scrollWrapper.scrollLeft = nextPosition;
                    ctrl.leftTimeout = setTimeout(moveLeft, 50);
                }

                function moveRight() {
                    var wraps = document.querySelectorAll('#scrollWrapper');

                    for (var i = 0; i < wraps.length; i++) {
                        if (wraps[i].parentElement.scrollWidth > 0) {
                            ctrl.scrollWrapper = wraps[i];
                            break;
                        }
                    }

                    if (!ctrl.scrollWrapper) {
                        return;
                    }
                    
                    if (!ctrl.scrollWrapper.scrollLeft) {
                        ctrl.scrollWrapper.scrollLeft = 0;
                    }

                    var parent = ctrl.scrollWrapper.parentElement;
                    var windowWidth = parent.clientWidth;
                    var scrollWidth = ctrl.scrollWrapper.scrollWidth;
                    var scrollDiff = scrollWidth - windowWidth;
                    scrollDiff = scrollDiff <= 0 ? 0 : scrollDiff;
                    var nextPosition = ctrl.scrollWrapper.scrollLeft += SCROLL_INTERVAL;

                    if (nextPosition > scrollDiff) {
                        ctrl.scrollWrapper.scrollLeft = scrollDiff;
                        return;
                    }
                    
                    ctrl.scrollWrapper.scrollLeft = nextPosition;
                    ctrl.rightTimeout = setTimeout(moveRight, 30);
                }

                function setWatchlistData() {
                    // TODO: Format raw data from server VM to suit needs in this view.
                    ctrl.watchlist.length = 0;

                    // Dummy data
                    ctrl.watchlist.push(
                        {
                            title: 'Lindsay Lou & The Flatbellys',
                            subtitle: 'With special guest Billy Strings',
                            month: 'Dec',
                            date: '7',
                            isPurchased: true,
                            isSellingFast: false,
                            isComingSoon: false
                        },
                        {
                            title: 'Nicki Bluhm',
                            subtitle: 'With special guest Compy Williams',
                            month: 'Dec',
                            date: '19',
                            isPurchased: false,
                            isSellingFast: true,
                            isComingSoon: false
                        },
                        {
                            title: 'The War & Treaty',
                            subtitle: '',
                            month: 'Jan',
                            date: '7',
                            isPurchased: false,
                            isSellingFast: false,
                            isComingSoon: false
                        },
                        {
                            title: 'Manatoba Reunion',
                            subtitle: 'With special guest Da Leafs',
                            month: 'Feb',
                            date: '4',
                            isPurchased: false,
                            isSellingFast: false,
                            isComingSoon: true
                        }
                    );


                }
            }]);
})();



(function () {
    angular.module('st')
        .controller('AddToWatchlistCtrl', [
            '$rootScope', '$scope', '$sce', '$http',
            function ($rootScope, $scope, $sce, $http) {
                var ctrl = this;

                ctrl.addToWatchlist = function (filmCode, event) {
                    event.preventDefault();
            
                    $http.post("/rpc/membership/account/shows/add/" + filmCode)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.isInWatchlist = true;
                                // success
                            } else {
                                // vista error
                                alert('Error occurred while adding show to the watchlist.')
                            }
                        }).catch(function (error) {
                            // our server error
                            alert('Error occurred while adding show to the watchlist.')
                        })
                }

                ctrl.removeFromWatchlist = function (filmCode, event) {
                    event.preventDefault();

                    $http.post("/rpc/membership/account/shows/remove/" + filmCode)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.isInWatchlist = false;
                                // success
                            } else {
                                // vista error
                                alert('Error occurred while removing show from the watchlist.')
                            }
                        }).catch(function (error) {
                            // our server error
                            alert('Error occurred while removing show from the watchlist.')
                        })
                }

                ctrl.initWatchlist = function (filmCode) {
                    $scope.isInWatchlist = false;
                    $scope.showWatchlistLink = false;

                    $http.get("/rpc/membership/account/shows")
                        .then(function (data) {
                            if (data.data.Success == true) {
                                // success
                                $scope.showWatchlistLink = true;

                                for (var i = 0; i < data.data.Data.length; i++) {
                                    var film = data.data.Data[i];
                                    if (film.HOFilmCode == filmCode) {
                                        $scope.isInWatchlist = true;
                                    }
                                }
                            }
                        })
                }
            }]);
})();
